import { withRequiredAuthInfo, WithAuthInfoProps } from "@propelauth/react";
import ListOfProjectCards from "../projects/ProjectCard_v2";
import { Button } from "../ui/button";
import { useNavigate } from "react-router-dom";

function BuilderHome(props: WithAuthInfoProps) {
    // console.log("home ", props.accessToken!);
    const navigate = useNavigate()
    return (
        <div className="container">
            <div className="columns-2 justify-between flex">
                     <h3 className="mb-2 text-lg font-semibold text-gray-800">
                Your projects
            </h3>
                <Button variant={'outline'}
                        onClick={(e) => navigate("project/create")}
                        className="mb-2">
                    Create New project
                </Button>
            </div>
            <ListOfProjectCards />
        </div>
    );
}


export default withRequiredAuthInfo(BuilderHome);
